export const CARD_STATUS = {
  false: '1ª via',
  true: '2ª via'
}
